import React, { ReactNode, useEffect, useState } from "react";
import { Button } from "@wearewqa/wqa-design-system";
import { DownloadItemType } from "../../types";
import { getVersionsByAppId } from "../../resources/apps/getVersionsByAppId";
import { useAuth } from "../../hooks/auth.provider";
import { CreateVersionModal } from "../../modals/CreateVersionModal";
import { sort } from "../../utilities";
import { AreYouSureModal } from "../../modals/AreYouSureModel";
import { deleteVersion } from "../../resources/versions";
import { ItemRow } from "../../components/ItemRow";
import { isDownloadVersionType } from "../../utilities/isDownloadVersionType";

type AppPageVersionListType = {
  appId: string | undefined;
  storeId: string | number;
};

export const AppPageListVersion = ({
  appId,
  storeId,
}: AppPageVersionListType) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [versionData, setVersionData] = useState<DownloadItemType[] | null>(
    null
  );
  const { isAuthenticated, currentUser } = useAuth();

  // confirmation Model - TODO: find a better way.
  const [confirmationModel, setConfirmationModel] = useState<ReactNode | null>(
    null
  );

  async function handleDeleteVersion(versionId: string) {
    try {
      if (!currentUser) {
        return;
      }
      const idToken = await currentUser.getIdToken();
      await deleteVersion(versionId, idToken);
      window.location.reload();
    } catch (error) {
      console.error("AppPageListVerions - handleDeleteVersion: ", error);
    }
  }

  useEffect(() => {
    async function getData() {
      try {
        if (typeof appId !== "string") {
          console.error('Error: URL parameter "appId" is not a string.');
          return;
        }

        const versions = await getVersionsByAppId(appId, { store_id: storeId });

        // Sort version by Created_at
        const sortedArray = sort<DownloadItemType>(
          versions.body,
          "created_at",
          "decending"
        );

        setVersionData(sortedArray);
      } catch (error) {
        console.error("getAppData: ", error);
      }
    }

    void getData();
  }, [appId, storeId]);

  return (
    <div className="app-page__app-list">
      {versionData !== null && versionData.length && (
        <Button
          href={
            versionData[0].manifest_location
              ? `itms-services://?action=download-manifest&url=${versionData[0].manifest_location}`
              : versionData[0].file_location
          }
          className="app-page__lastest"
          label={`Download Lastest Version: ${versionData[0].version_number} ${isDownloadVersionType(versionData[0]) ? `(${versionData[0].build_number})` : ""}`}
          icon={storeId === 1 ? "apple" : "google"}
        />
      )}
      <div>
        <h2 className="app-page__sub-header">Version History</h2>
        <p>
          Download previous build here. Please note these build should be used
          as reference only. Please use the latest build for QA & Testing
          purposes.
        </p>

        {isAuthenticated && appId && (
          <>
            <Button
              label="Upload a new Version"
              onClick={() => setShowForm(true)}
            />
            <CreateVersionModal
              isOpen={showForm}
              onClose={() => setShowForm(false)}
              appId={appId}
            />
          </>
        )}
      </div>
      {versionData !== null && versionData.length ? (
        <div className="app-page__list">
          {versionData.map((current, index) => (
            <ItemRow
              data={current}
              key={index}
              onDelete={() =>
                setConfirmationModel(
                  <AreYouSureModal
                    isOpen={true}
                    message={`You are about to DELETE version: "${current.display_name || current.version_number}".`}
                    onAccept={() =>
                      void handleDeleteVersion(String(current.id))
                    }
                    onClose={() => setConfirmationModel(null)}
                  />
                )
              }
            />
          ))}
        </div>
      ) : (
        <>No Data Found!</>
      )}

      {confirmationModel}
    </div>
  );
};
